import { render, staticRenderFns } from "./MovieInfoModalContent.vue?vue&type=template&id=61372384&scoped=true&"
import script from "./MovieInfoModalContent.vue?vue&type=script&lang=js&"
export * from "./MovieInfoModalContent.vue?vue&type=script&lang=js&"
import style0 from "./MovieInfoModalContent.vue?vue&type=style&index=0&id=61372384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61372384",
  null
  
)

export default component.exports